import { ViewMode } from '@app/domain/model/ViewModeType';
import { useCallback, useState } from 'react';

export function useCalendarState(defaultValue?: Date, isMonthPicker = false, initialViewDate?: Date) {
    const [selectedDate, setSelectedDate] = useState<Date | null>(defaultValue || null);
    const [currentMonth, setCurrentMonth] = useState<Date>(defaultValue || initialViewDate || new Date());
    const [currentYear, setCurrentYear] = useState<Date>(defaultValue || initialViewDate || new Date());
    const [viewMode, setViewMode] = useState<ViewMode>(isMonthPicker ? ViewMode.Months : ViewMode.Days);
    const [open, setOpen] = useState(false);

    const reset = useCallback(() => {
        setSelectedDate(null);
    }, []);

    const navigateMonth = useCallback(
        (direction: 'prev' | 'next', yearRange = 10) => {
            setCurrentMonth(prev => {
                const newDate = new Date(prev);
                const delta = direction === 'prev' ? -1 : 1;

                switch (viewMode) {
                    case ViewMode.Days:
                        newDate.setMonth(newDate.getMonth() + delta);
                        break;
                    case ViewMode.Months:
                        newDate.setFullYear(newDate.getFullYear() + delta);
                        break;
                    case ViewMode.Years:
                        newDate.setFullYear(newDate.getFullYear() + delta * yearRange * 2);
                        break;
                }
                return newDate;
            });
        },
        [viewMode],
    );

    const navigateYear = useCallback((direction: 'prev' | 'next') => {
        setCurrentYear(prev => {
            const newDate = new Date(prev);
            const delta = direction === 'prev' ? -1 : 1;

            newDate.setFullYear(newDate.getFullYear() + delta);
            return newDate;
        });
    }, []);

    const navigateTenYears = useCallback((direction: 'prev' | 'next', yearRange = 10) => {
        setCurrentYear(prev => {
            const newDate = new Date(prev);
            const delta = direction === 'prev' ? -1 : 1;

            newDate.setFullYear(newDate.getFullYear() + delta * yearRange);
            return newDate;
        });
    }, []);

    return {
        selectedDate,
        setSelectedDate,
        currentMonth,
        setCurrentMonth,
        viewMode,
        setViewMode,
        open,
        setOpen,
        reset,
        navigateMonth,
        navigateYear,
        navigateTenYears,
        currentYear,
        setCurrentYear,
        ViewMode,
    };
}
